<template>
  <v-dialog max-width="40%" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-if="instance.archived" v-on="on" color="black">
              mdi-sleep
            </v-icon>
            <v-icon v-else v-on="on" color="primary">mdi-run-fast</v-icon>
          </template>
          <span v-if="instance.archived">Reactivate</span>
          <span v-else>Send To Archive</span>
        </v-tooltip>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline" v-if="instance.archived">
        UnArchive
      </v-card-title>
      <v-card-title class="headline" v-else>
        Archive
      </v-card-title>
      <v-card-text v-if="instance.archived">
        This will un-archive your selection so that it can be worked on again.
      </v-card-text>
      <v-card-text v-else>
        Archiving will cause all workorders and batches for a project to
        archive. Are you sure you want to do this? You can un-archive a project
        at any time.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close" color="primary">
          <v-icon left small>close</v-icon>
          Close
        </v-btn>
        <v-btn @click="archive" color="success" v-if="instance.archived">
          <v-icon left small>mdi-package-up</v-icon>
          UnArchive
        </v-btn>
        <v-btn @click="archive" color="error" v-else>
          <v-icon left small>mdi-package-down</v-icon>
          Archive
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ArchiveForm",
  data() {
    return {
      dialog: false
    };
  },
  props: {
    instance: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  methods: {
    archive() {
      // capture both situations. either a project is already archived and it must be unarchived or a project needs
      // to be archived.
      this.instance.archived = !this.instance.archived;
      this.instance.constructor
        .$patch(this.instance.id, { archived: this.instance.archived })
        .then(() => this.close())
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

